import * as React from 'react'

import { Box, Button, Icon, Table, Text } from '@factorialco/deprecated-design-system'
import copy from 'copy-to-clipboard'

import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import type Variable from 'modules/documents/store/models/Variable'

import AccessInfo from './AccessInfo'
import MainLegalEntity from './MainLegalEntity'
import RelatedLegalEntities from './RelatedLegalEntities'

interface Props {
  variable: Variable
}

const copyText = (text: string) => (event: React.SyntheticEvent<Element, Event>) => {
  event.preventDefault()
  text && copy(text, { format: 'text/plain' })
  app.setFlash({
    type: 'correct',
    message: i18n.t('common.copied'),
  })
}

const TableRow = ({ variable }: Props) => {
  return (
    <Table.Row>
      <Table.Cell colSpan={3}>
        <Box flexDirection="row" alignItems="center">
          <Box>
            {variable.attributes.is_custom_field && (
              <Icon.Medium icon="input-field" color={'grey800'} />
            )}
          </Box>

          <Text.Normal weight="medium" size="200" overflowWrap>
            {variable.attributes.name}
          </Text.Normal>
        </Box>
      </Table.Cell>

      <Table.Cell colSpan={2}>
        <Text.Normal size="200" weight="medium">
          {variable.attributes.section}
        </Text.Normal>
      </Table.Cell>

      <Table.Cell colSpan={2}>
        <Box flexDirection="row" alignItems="center" gap="s2">
          <MainLegalEntity legalEntity={variable.attributes.legal_entities[0] as string} />
          {variable.attributes.legal_entities.length > 1 && (
            <RelatedLegalEntities
              legalEntities={variable.attributes.legal_entities}
            ></RelatedLegalEntities>
          )}
        </Box>
      </Table.Cell>

      <Table.Cell colSpan={2}>
        <AccessInfo
          access={variable.attributes.access}
          permission={variable.attributes.permission_label}
          showLabel
        />
      </Table.Cell>

      <Table.Cell colSpan={2}>
        <Box flexDirection="row" alignItems="center">
          <Text.Normal weight="medium" size="200" overflowWrap>
            {variable.attributes.variable}
          </Text.Normal>
        </Box>
      </Table.Cell>

      <Table.Cell colSpan={1}>
        <Box flexDirection="rowReverse">
          <Button
            onClick={copyText(variable.attributes.variable)}
            type="secondary"
            iconName="layers-front"
          />
        </Box>
      </Table.Cell>
    </Table.Row>
  )
}

export default TableRow
